import React from 'react';
import autoLocation from '../../assets/icons/locate@2x.png';
import './styles/Map.css';

const MapControls = ({ onZoomIn, onZoomOut, onAutoLocate, isLocating }) => {
  return (
    <div className="map-controls">
      <button className="zoom-in-btn" onClick={onZoomIn}>+</button>
      <button className="zoom-out-btn" onClick={onZoomOut}>-</button>
      <button 
        className="auto-location-btn" 
        onClick={onAutoLocate} 
        disabled={isLocating}
      >
        <img src={autoLocation} alt="Show me where I am" />
      </button>
    </div>
  );
};

export default MapControls; 